export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Breath control, vocal projection, and resonance.</li>
                                <li>Voice placement, vowel modification, and tone clarity.</li>
                                <li>Learning Italian, German, and French repertoire.</li>
                                <li>Classical operatic stage presence & storytelling through music.</li>
                                <li>Advanced stylistic interpretation with professional coaching.</li>
                            </ul>
                        </div>
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Beginners eager to explore Western classical singing.</li>
                                <li>Stage performers and competition aspirants.</li>
                                <li>Advanced students aiming for opera careers internationally.</li>
                                <li>Students wishing to learn directly under India’s first opera singer, Harshita Rewadia.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Enhanced vocal stamina and expanded range.</li>
                                <li>Ability to sing opera arias with confidence.</li>
                                <li>Strong stage presence & storytelling ability.</li>
                                <li>International-level training & career readiness.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 